/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EUserProductType = 'Normal' | 'DemoBike' | 'EgorepBike';

export const EUserProductType = {
    Normal: 'Normal' as EUserProductType,
    DemoBike: 'DemoBike' as EUserProductType,
    EgorepBike: 'EgorepBike' as EUserProductType
};

